import AppLayout from "../components/layout/AppLayout";
import DocumentTableComponent from "../components/document/DocumentTableComponent";

export default function ClientwiseDocument() {
  return (
    <AppLayout>
      <DocumentTableComponent category="clientwise" />
    </AppLayout>
  );
}
